var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.transitionName || 'div',{tag:"component",attrs:{"mode":"in"}},[_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentItem),expression:"currentItem"}]},[_vm._t("default",[_vm._v("remove")])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }